import React, { Fragment, FunctionComponent, useEffect } from 'react';
import styles from './TcmWorkStatus.Styles';
import { Grid } from '@material-ui/core';
import { EmptyDataLabel } from '../../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import TcmWorkStatusEntity from '../../../../../../entities/tcm/TcmWorkStatus.Entity';
import { TooltipTextField } from '../../../../../generic-components/tooltip-textfield/TooltipTextField.Component';
import Moment from 'moment';

interface ITcmWorkStatusProps {
    referralId: number;
    tcmWorkStatus?: TcmWorkStatusEntity;
    handleTcmWorkStatusEdit: (status: TcmWorkStatusEntity) => void;
}

export const TcmWorkStatus: FunctionComponent<ITcmWorkStatusProps> = (props: ITcmWorkStatusProps) => {
    const classes = styles();

    const [workStatusState, setWorkStatusState] = React.useState<TcmWorkStatusEntity>(
        props.tcmWorkStatus || { referralId: props.referralId }
    );

    useEffect(() => {
        if (props.tcmWorkStatus) {
            setWorkStatusState(props.tcmWorkStatus);
        }
    }, [props.tcmWorkStatus]);

    const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        let newWorkStatus: TcmWorkStatusEntity = { ...workStatusState };
        if (!newWorkStatus.referralId) {
            newWorkStatus.referralId = props.referralId;
        }

        newWorkStatus[event.target.id || event.target.name] = event.target.value;

        setWorkStatusState(newWorkStatus);
        props.handleTcmWorkStatusEdit(newWorkStatus);
    };

    return (
        <Fragment>
            {workStatusState ? (
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={6}>
                        <TooltipTextField
                            label="Physical Demand Level"
                            id="physicalDemandLevel"
                            value={workStatusState?.physicalDemandLevel || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TooltipTextField
                            label="Work Status"
                            id="workStatus"
                            value={workStatusState?.workStatus || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TooltipTextField
                            type="date"
                            id="workStatusEffectiveDate"
                            name="workStatusEffectiveDate"
                            label="Work Status Effective Date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            //key={serviceTypeRequestDme?.requestDeliveryDate}
                            value={
                                workStatusState?.workStatusEffectiveDate
                                    ? Moment(workStatusState?.workStatusEffectiveDate)?.format('YYYY-MM-DD')
                                    : ''
                            }
                            onChange={handleTextFieldChange}
                            style={{ width: 200 }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TooltipTextField
                        type="date"
                        id="estimatedRtwDate"
                        name="estimatedRtwDate"
                        label="Estimated RTW Date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={
                            workStatusState?.estimatedRtwDate
                                ? Moment(workStatusState?.estimatedRtwDate)?.format('YYYY-MM-DD')
                                : ''
                        }
                        onChange={handleTextFieldChange}
                        style={{ width: 200 }}
                    />
                    </Grid>

                    <Grid item xs={12}>
                        <TooltipTextField
                            maxRows={4}
                            multiline={true}
                            label="Work Status Remark"
                            id="workStatusRemark"
                            value={workStatusState?.workStatusRemark || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 500 }}
                            helperText={`${workStatusState?.workStatusRemark ? workStatusState.workStatusRemark.length : 0}/${500}`}
                        />
                    </Grid>
                </Grid>
            ) : (
                <EmptyDataLabel />
            )}
        </Fragment>
    );
};

